<template>
    <div class="DialogReportPaid__Component">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">תצוגה מקדימה לכרטיסייה {{ id }}</p>
                <button type="button" class="delete" @click="$emit('close')" />
            </header>
            <section class="modal-card-body">
                <div class="DialogReportPaid__Component__Loading">
                    <b-field :label="frontLabel">
                        <div class="flip-card-side">
                            <div v-if="model.question" v-html="model.question"></div>
                            <b-field v-if="model.detailedAnswer">
                                <div v-html="model.detailedAnswer"></div>
                            </b-field>
                            <div v-for="(item, idx) in frontSideItems" :key="`front-${idx}`" class="flip-card-item">
                                <div v-if="item.contentTypeId === 1" v-html="item.textContent"></div>
                                <img v-else-if="item.contentTypeId === 2" :src="item.imageUrl" />
                                <div v-else-if="item.contentTypeId === 3" class="flip-card-video-placeholder">
                                    וידאו (id: {{ item.videoId }})
                                </div>
                                <audio v-else-if="item.contentTypeId === 4" :src="item.audioUrl" controls />
                            </div>
                        </div>
                    </b-field>

                    <b-field v-if="hasBackSide" :label="backLabel">
                        <div class="flip-card-side">
                            <div v-for="(item, idx) in backSideItems" :key="`back-${idx}`" class="flip-card-item">
                                <div v-if="item.contentTypeId === 1" v-html="item.textContent"></div>
                                <img v-else-if="item.contentTypeId === 2" :src="item.imageUrl" />
                                <div v-else-if="item.contentTypeId === 3" class="flip-card-video-placeholder">
                                    וידאו (id: {{ item.videoId }})
                                </div>
                                <audio v-else-if="item.contentTypeId === 4" :src="item.audioUrl" controls />
                            </div>
                        </div>
                    </b-field>

                </div>
            </section>
            <footer class="modal-card-foot">
                <b-button :disabled="isLoading" label="סגור" @click="$emit('close')" />
            </footer>
        </div>
    </div>
</template>

<script>
import LessonService from "../services/LessonService";

export default {
    name: "DialogFlipCardPreview",
    props: ["id", "store"],
    components: {
    },
    computed: {
        questionId() {
            return this.store.state.question?.id;
        },
        frontSideItems() {
            return (this.model.flipCardItems || []).filter(i => i.side === 1);
        },
        backSideItems() {
            return (this.model.flipCardItems || []).filter(i => i.side === 2);
        },
        hasBackSide() {
            return this.model.isTwoSided && this.backSideItems.length > 0;
        },
        frontLabel() {
            return "צד קדמי";
        },
        backLabel() {
            return "צד אחורי";
        },
    },
    created() {
        this.getFlipCardPreview();
    },
    data() {
        return {
            submitted: false,
            isLoading: false,
            model: {
                question: null,
                detailedAnswer: null,
                sortOrder: null,
                isTwoSided: false,
                flipCardItems: []
            }
        };
    },
    methods: {
        getFlipCardPreview() {
            LessonService.getFlipCardPreview(this.id)
                .then((r) => {
                    this.model = r.data;
                });
        },
    },
};
</script>

<style scoped lang="scss">
.flip-card-side {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    pointer-events: none;
    border: 1px solid rgb(180, 178, 178);
    border-radius: 10px;
    padding: 10px;
}

.flip-card-item {
    img {
        max-width: 100%;
        height: auto;
    }

    audio,
    video {
        pointer-events: auto;
    }
}

.flip-card-video-placeholder {
    padding: 8px 12px;
    border: 1px dashed #aaa;
    color: #666;
    font-size: 0.9em;
}

.DialogReportPaid__Component__Loading {
    overflow: auto;
    max-height: 600px;

    ::v-deep ol {
        list-style-type: decimal;
        margin: revert;
        padding: revert;
    }

    ::v-deep ol ol {
        list-style-type: lower-alpha;
    }

    ::v-deep ol ol ol {
        list-style-type: lower-roman;
    }

    ::v-deep ul {
        list-style-type: disc;
        margin: revert;
        padding: revert;
    }
}
</style>
